import { SECTION_CARD_STYLE, SECTION_TITLE_STYLE } from '../../utils';

const ModalSection = ({
    title,
    children,
    titleStyle = SECTION_TITLE_STYLE,
    sectionClassName = 'mb-md-4',
}) => (
    <section className={sectionClassName}>
        <h6
            className="fw-bold text-uppercase mb-2 mb-md-3"
            style={titleStyle}
        >
            {title}
        </h6>
        {children}
    </section>
);

const ModalPanel = ({
    children,
    className = 'card p-3 mb-4',
    style = SECTION_CARD_STYLE,
}) => (
    <div className={className} style={style}>
        {children}
    </div>
);

export { ModalSection, ModalPanel };
